// extracted by mini-css-extract-plugin
var _1 = "MessageFolders-moduleMessageFolders__JD_iu";
export { _1 as "MessageFolders" }
